import React from 'react';
import { Icon } from './Icon.js';
export const IconMerge3 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M16 6L12 2L8 6", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M5 21L12 12L12 2L12 3", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M19.79 20.3867L20.4033 21.1758L18.8252 22.4033L18.2109 21.6143L13.2676 15.2588L14.5342 13.6299L19.79 20.3867Z", fill: "currentColor", "data-color": "color-2", "data-stroke": "none" })));
};
//# sourceMappingURL=IconMerge3.js.map